import { z } from 'zod';

import { QUESTION_TYPE } from 'types/question.types';

import { BaseQuestionSchema, getOptionsSchema } from './BaseQuestionSchema';

/**
 * Form Data Structure (UI Format) (SingleChoiceFormInput):
 * {
 *   label: string,
 *   type: QUESTION_TYPE.RADIO,
 *   isRequired: boolean,
 *   options: Array<{ value: string }>,
 *   hasOtherOption: boolean
 * }
 *
 * Database Data Structure (SingleChoiceFormValues):
 * {
 *   label: string,
 *   type: QUESTION_TYPE.RADIO,
 *   isRequired: boolean,
 *   options: string[],
 *   hasOtherOption: boolean
 * }
 */

// Schema for form data with transform to DB format
export const SingleChoiceSchema = BaseQuestionSchema.extend({
  type: z.literal(QUESTION_TYPE.RADIO),
  options: getOptionsSchema(2, 'A single choice question requires at least 2 options'),
  hasOtherOption: z.boolean()
});

export type SingleChoiceFormInput = z.input<typeof SingleChoiceSchema>; // Form values
export type SingleChoiceFormValues = z.infer<typeof SingleChoiceSchema>; // DB values

export const SINGLE_CHOICE_DEFAULTS: SingleChoiceFormValues = {
  label: '',
  type: QUESTION_TYPE.RADIO,
  isRequired: false,
  options: ['Yes', 'No'],
  hasOtherOption: false
};
